import { Component, Output, EventEmitter, Inject, ViewChild, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { notification } from './data';
import { RootReducerState } from 'src/app/store';
import { Store } from '@ngrx/store';
import { changeMode } from 'src/app/store/layouts/layout-action';
import { getLayoutmode } from 'src/app/store/layouts/layout-selector';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/base/base/base.component';

/* Models */
import { Employee } from '../../core/models/employee-view';
import { User } from '../../core/models/user-account';
import { Task } from '../../core/models/task';
import { Notification } from '../../core/models/notification';

/* Services */
import { EmployeeService } from '../../core/services/employee.service';
import { UserService } from '../../core/services/user-main.service';
import { BaseService } from 'src/app/core/services/base.service';
import { CookieService } from 'ngx-cookie-service';
import { EventService } from 'src/app/core/services/event.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { TokenStorageService } from 'src/app/core/services/token-storage.service';
import { TokenAuthService } from 'src/app/core/services/tokenauth.service';
import { TaskService } from '../../core/services/task.service';
import { NotificationService } from '../../core/services/notifications.service';
import { HubService } from 'src/app/core/services/hub.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent extends BaseComponent implements OnInit {

  user = {} as User;
  employee = {} as Employee;

  country: any;
  selectedItem!: any;

  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  userData: any;
  cartData: any;

  element: any;
  mode: string | undefined;

  total: any;
  subtotal: any = 0;
  totalsum: any;
  taxRate: any = 0.125;
  shippingRate: any = '65.00';
  discountRate: any = 0.15;
  discount: any;
  tax: any;

  currentuser = {} as any;

  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChild('removeNotificationModal', { static: false }) removeNotificationModal?: ModalDirective;
  @ViewChild('removeCartModal', { static: false }) removeCartModal?: ModalDirective;
  deleteid: any;
  totalNotify: number = 0;
  newNotify: number = 0;
  readNotify: number = 0;


  // Tasks
  tasks = [] as Task[];
  task = {} as Task;
  totalTasksNumber: number = 0;

  // Notifications
  notifications = [] as Notification[];
  notification = {} as Notification;
  totalNotificationsNumber: number = 0;

  // Loaders
  loadingUserData: boolean = false;
  

  constructor(@Inject(DOCUMENT) private document: any,
    private eventService: EventService,
    private tokenAuthService: TokenAuthService,
    public languageService: LanguageService,
    private authService: AuthenticationService,
    private router: Router,
    public _cookiesService: CookieService,
    public store: Store<RootReducerState>,
    private employeeService: EmployeeService,
    public baseService: BaseService,
    private userService: UserService,
    private TokenStorageService: TokenStorageService,
    private taskService: TaskService,
    private notificationService: NotificationService,
    public hubService: HubService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const currentUser = this.tokenAuthService.currentUserValue();
    this.currentuser = currentUser;

    // Tasks
    this.loadTasks();
    this.hubService.taskUpdated$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((updatedTask) => {
      this.updateTaskList(updatedTask);
    });

    // Notifications
    this.loadNotifications();
    this.hubService.notificationUpdated$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((updatedNotification) => {
      this.updateNotificationList(updatedNotification);
    })

    if (this.currentuser.empId === 0) {
      await this.loadUserData();
    }
    else if (currentUser.empId !== 0) {
      await this.loadEmployeeData();
    }


    this.element = document.documentElement;


    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }
      this.countryName = 'English'
    } else {
      this.flagvalue = val.map(element => element.flag);
    }


    // Hub Connection
    this.hubService.startConnection(this.currentuser.userId);
    var x = this.hubService.updateRequestNotificationDataListener();
    var y = this.hubService.updateNotificationDataListener();
  }

  // Update Task List
  updateTaskList(taskArray: Task[]) {
    debugger
    if (taskArray && taskArray.length > 0) {
      const lastTask = taskArray[taskArray.length - 1]; 
      this.task = {} as Task;
      this.task = lastTask;
      this.tasks.push(this.task);
      this.totalTasksNumber = this.tasks.length;
    }
  }

  // Update Notification List
  updateNotificationList(notificationArray: Notification[]) {
    if (notificationArray && notificationArray.length > 0) {
      const lastNotification = notificationArray[notificationArray.length - 1]; 
      this.notification = {} as Notification;
      this.notification = lastNotification;
      this.notifications.push(this.notification);
      this.totalNotificationsNumber = this.notifications.length;
    }
  }

  // Emp and User Data
  private loadEmployeeData(): Promise<void> {
    this.loadingUserData = true;
    return new Promise((resolve) => {
      this.employeeService.getEmpByIdDetails(this.currentuser.empId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.employee = data.result.returnData;
          this.loadingUserData = false;
          resolve();
        }
      );
    });
  }

  private loadUserData(): Promise<void> {
    this.loadingUserData = true;
    return new Promise((resolve) => {
      this.userService.getUserDataById(this.currentuser.userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        (data: any) => {
          this.user = data.result.returnData;
          this.loadingUserData = false;
          resolve();
        }
      );
    });
  }

  onImgError(evt: Event) {
    const img = evt.target as HTMLImageElement | null;
    if (img) {
      img.onerror = null;
      img.src = 'assets/images/Avatar.png';
    }
  }
  windowScroll() {
    // if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    //   (document.getElementById('back-to-top') as HTMLElement).style.display = "block";
    //   document.getElementById('page-topbar')?.classList.add('topbar-shadow')
    // } else {
    //   (document.getElementById('back-to-top') as HTMLElement).style.display = "none";
    //   document.getElementById('page-topbar')?.classList.remove('topbar-shadow')
    // }
  }

  // Increment Decrement Quantity
  qty: number = 0;
  increment(qty: any, i: any, id: any) {
    this.subtotal = 0;
    if (id == '0' && qty > 1) {
      qty--;
      this.cartData[i].qty = qty
      this.cartData[i].total = (this.cartData[i].qty * this.cartData[i].price).toFixed(2)
    }
    if (id == '1') {
      qty++;
      this.cartData[i].qty = qty
      this.cartData[i].total = (this.cartData[i].qty * this.cartData[i].price).toFixed(2)
    }

    this.cartData.map((x: any) => {
      this.subtotal += parseFloat(x['total'])
    })

    this.subtotal = this.subtotal.toFixed(2)
    this.discount = (this.subtotal * this.discountRate).toFixed(2)
    this.tax = (this.subtotal * this.taxRate).toFixed(2);
    this.totalsum = (parseFloat(this.subtotal) + parseFloat(this.tax) + parseFloat(this.shippingRate) - parseFloat(this.discount)).toFixed(2)
  }


  // Topbar Light-Dark Mode Change
  changeMode(mode: string) {
    this.mode = mode;
    if (mode == 'auto') {
      document.documentElement.setAttribute('data-bs-theme', 'light')
      document.documentElement.setAttribute('data-topbar', 'light');
      document.documentElement.classList.add('mode-auto')
    } else {
      this.store.dispatch(changeMode({ mode }));
      this.store.select(getLayoutmode).subscribe((mode) => {
        document.documentElement.setAttribute('data-bs-theme', mode);
      })
      document.documentElement.classList.remove('mode-auto')
      document.documentElement.setAttribute('data-topbar', mode);
    }
  }

  // Language Listing
  listLang = [
    { text: 'Arabic', flag: 'assets/images/flags/ae.svg', lang: 'ar' },
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' }
  ];

  // Language Value Set
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  //Toggle the menu bar when having mobile screen
  toggleMobileMenu(event: any) {
    document.querySelector('.hamburger-icon')?.classList.toggle('open')
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  // Fullscreen method
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  // Logout the user
  logout() {
    this.tokenAuthService.logout();
    localStorage.removeItem('accessToken');
    this.router.navigate(['/auth/login']);
  }

  // Profile
  goToProfile() {
    this.router.navigate(['/employees/account-details']);
  }

  // Tasks
  loadTasks() {
    this.taskService.getAllCurrentTaskForUser(this.currentuser.userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.tasks = data.result
        this.totalTasksNumber = this.tasks.length;
      }
    )
  }

  goToDeatils(recordId: number, processActionId: number, excutedProcessID: number, dataURL: string) {
    const encodedURL = encodeURIComponent(dataURL);
    this.router.navigate(['/task', recordId, processActionId, excutedProcessID, encodedURL]);
  }

  // Notifications
  loadNotifications() {
    this.notificationService.getAllCurrentNotificationForUser(this.currentuser.userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.notifications = data.result;
        this.totalNotificationsNumber = this.notifications.length;
      }
    )
  }
}
